var ur = window.location.href;
if(ur.includes('/product')){
    jQuery(document).ready(function(){
  if(!$('body').hasClass('vwo-test')){
 $('a.cart_button').click(function(e){
  e.preventDefault();
    if(!$('body').hasClass('vwo-test')){
   window.location.href = "/cart";
    }
}); 

 jQuery(document).ready(function(){
jQuery('.add_to_cart').click(function(){
jQuery('body').addClass('conv-redirect');
  var count = jQuery('span.cart-count').html();
  var x = 0;
var cTimer = setInterval(function(){
  if(count != jQuery('span.cart-count').html() || x > 200) {
    if(!$('body').hasClass('vwo-test')){
	 window.location.href = '/cart';
    }
     clearInterval(cTimer);
  }
x++;
}, 50);
});
 
});       
  }
   
    var ss = 0; var timerss = setInterval(function(){
  if(jQuery('span[name="Kicker Custom Minimal2"]').eq(0).length) {
	 jQuery('.comparebtn.clearfix').eq(0).before(jQuery('span[name="Kicker Custom Minimal2"]').eq(0));
clearInterval(timerss);}if( ss > 200){clearInterval(timerss);}ss++;}, 50);
});

   var bb = 0; var timerbb = setInterval(function(){
  if(jQuery('.right_section klarna-placement').length && jQuery('span[name="Kicker Custom Minimal2"]').eq(0).length) {
	jQuery('span[name="Kicker Custom Minimal2"]').eq(0).before(jQuery('.right_section klarna-placement').eq(0));
   
clearInterval(timerbb);}if( bb > 200){clearInterval(timerbb);}bb++;}, 50);
  
}


var ur = window.location.href;
if(ur.includes('/product') && window.innerWidth > 768){
 
  jQuery(document).ready(function(){
    var title = jQuery('div#judgeme_product_reviews').parent().find('h2').eq(0)
  jQuery('ul.tabs').eq(0).before(jQuery('div#judgeme_product_reviews'));
    jQuery('div#judgeme_product_reviews').before(title)
});
  
}




var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
if(jQuery('.info-box').length == 0){
  var b = 'Our Guarantee';
  var t = "Extreme Wellness Supply is a trusted for real food nutrition seekers — like fitness-and-health-oriented individuals, healthy food restaurant owners, and raw foodists — with over 1,000 ⭐⭐⭐⭐⭐️ reviews. We have curated a collection that continues to grow all the time to help customers take charge of their health.";
  jQuery('.product .scroller').eq(0).after(jQuery('<div class="info-box">'+t+'</div>'));
}
});
}
